import { useMemo } from "react";
import useLineItemsState, {
  LineItemStateKey,
} from "./use-line-items-state-context";

type UseLineItemSectionSummaryParams = {
  state: LineItemStateKey;
};

/**
 * For a given section of line items, give how many have been selected, and how many can be selected
 */
export default function useLineItemsQuantitiesSummary({
  state: section,
}: UseLineItemSectionSummaryParams) {
  const { lineItemsState } = useLineItemsState();

  return useMemo(() => {
    return Object.keys(lineItemsState).reduce(
      (acc, next) => {
        const lineItem = lineItemsState[next];
        const quantity = lineItem[section].selectedQuantity;
        const maxQuantity = lineItem[section].maxQuantity;
        acc.selected += quantity;
        acc.max += maxQuantity;
        return acc;
      },
      { max: 0, selected: 0 },
    );
  }, [lineItemsState, section]);
}
